import { render, staticRenderFns } from "./GlobalChatNotifier.vue?vue&type=template&id=b193f65c&scoped=true"
import script from "./GlobalChatNotifier.vue?vue&type=script&lang=js"
export * from "./GlobalChatNotifier.vue?vue&type=script&lang=js"
import style0 from "./GlobalChatNotifier.vue?vue&type=style&index=0&id=b193f65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b193f65c",
  null
  
)

export default component.exports